// Things the page knows that the server does not, shared between the hooks
// that produce them and the ones that show them.

// Fired on `window` when speech-to-text starts or stops. `detail.listening`.
export const LISTENING_EVENT = 'brainbox:listening'

/**
 * Notify window listeners that speech recognition has started or stopped.
 * @param {boolean} listening - Whether speech recognition is listening.
 */
export function announceListening (listening) {
  window.dispatchEvent(new CustomEvent(LISTENING_EVENT, { detail: { listening } }))
}
